<!-- Squelette pour la grille des cartes de sites -->
<div class="row">
  <ng-container *ngFor="let k of sitesCards">
    <div class="col-xl-6 col-lg-12 col-md-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="d-flex flex-wrap justify-content-between align-items-center pb-2">
              <app-skeleton-rect 
                width="100%" 
                [style.max-width]="'180px'" 
                [style.min-width]="'120px'"
                height="20px" 
                class="mb-2 mb-sm-0">
              </app-skeleton-rect>
              <app-skeleton-rect 
                width="90px" 
                [style.min-width]="'70px'"
                height="22px" 
                [borderRadius]="'12px'">
              </app-skeleton-rect>
            </div>
            <div class="shop-card-content align-items-center">
              <div class="row shop-metrics-row">
                <div class="col-sm-6 col-12 d-flex align-items-start shop-metric-item">
                  <app-skeleton-rect 
                    width="60px" 
                    [style.min-width]="'50px'"
                    height="60px" 
                    [style.min-height]="'50px'"
                    [borderRadius]="'10px'" 
                    class="flex-shrink-0">
                  </app-skeleton-rect>
                  <div class="shop-metric-content flex-grow-1 min-width-0">
                    <app-skeleton-rect 
                      width="80%" 
                      [style.min-width]="'60px'"
                      height="12px" 
                      class="mb-2">
                    </app-skeleton-rect>
                    <app-skeleton-rect 
                      width="90%" 
                      [style.min-width]="'70px'"
                      height="16px">
                    </app-skeleton-rect>
                  </div>
                </div>
                <div class="col-sm-6 col-12 d-flex align-items-start shop-metric-item">
                  <app-skeleton-rect 
                    width="60px" 
                    [style.min-width]="'50px'"
                    height="60px" 
                    [style.min-height]="'50px'"
                    [borderRadius]="'10px'" 
                    class="flex-shrink-0">
                  </app-skeleton-rect>
                  <div class="shop-metric-content flex-grow-1 min-width-0">
                    <app-skeleton-rect 
                      width="80%" 
                      [style.min-width]="'60px'"
                      height="12px" 
                      class="mb-2">
                    </app-skeleton-rect>
                    <app-skeleton-rect 
                      width="90%" 
                      [style.min-width]="'70px'"
                      height="16px">
                    </app-skeleton-rect>
                  </div>
                </div>
              </div>
              <div class="row shop-metrics-row">
                <div class="col-sm-6 col-12 d-flex align-items-start shop-metric-item">
                  <app-skeleton-rect 
                    width="60px" 
                    [style.min-width]="'50px'"
                    height="60px" 
                    [style.min-height]="'50px'"
                    [borderRadius]="'10px'" 
                    class="flex-shrink-0">
                  </app-skeleton-rect>
                  <div class="shop-metric-content flex-grow-1 min-width-0">
                    <app-skeleton-rect 
                      width="80%" 
                      [style.min-width]="'60px'"
                      height="12px" 
                      class="mb-2">
                    </app-skeleton-rect>
                    <app-skeleton-rect 
                      width="90%" 
                      [style.min-width]="'70px'"
                      height="16px">
                    </app-skeleton-rect>
                  </div>
                </div>
                <div class="col-sm-6 col-12 d-flex align-items-start shop-metric-item">
                  <app-skeleton-rect 
                    width="60px" 
                    [style.min-width]="'50px'"
                    height="60px" 
                    [style.min-height]="'50px'"
                    [borderRadius]="'10px'" 
                    class="flex-shrink-0">
                  </app-skeleton-rect>
                  <div class="shop-metric-content flex-grow-1 min-width-0">
                    <app-skeleton-rect 
                      width="80%" 
                      [style.min-width]="'60px'"
                      height="12px" 
                      class="mb-2">
                    </app-skeleton-rect>
                    <app-skeleton-rect 
                      width="90%" 
                      [style.min-width]="'70px'"
                      height="16px">
                    </app-skeleton-rect>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap justify-content-center justify-content-sm-end pt-4">
                <app-skeleton-rect 
                  width="120px" 
                  [style.min-width]="'100px'"
                  height="30px" 
                  [borderRadius]="'6px'" 
                  class="me-2 mb-2 mb-sm-0">
                </app-skeleton-rect>
                <app-skeleton-rect 
                  width="130px" 
                  [style.min-width]="'110px'"
                  height="30px" 
                  [borderRadius]="'6px'">
                </app-skeleton-rect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
